
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormatTimeModule } from '@go-modules/pipes/format-time/format-time.module';
import { CardContainerModule } from '@go-modules/components/card-container/card-container.module';
import { DotIndicatorModule } from '@go-modules/components/dot-indicator/dot-indicator.module';
import { EllipsisWithCountModule } from '@go-modules/components/ellipsis-with-count/ellipsis-with-count.module';
import { SessionMenuModule } from '@go-modules/components/activity-view/session-menu/session-menu.module';
import { ThumbnailModule } from '@go-modules/components/thumbnail/thumbnail.module';
import { SessionCardComponent } from './session-card.component';
import { MenuModule } from '@go-modules/components/menus/menu/menu.module';
import { LoadingModule } from '@go-modules/components/loading/loading.module';
import { DetectTextTruncationDirective } from '@go-modules/directives/truncate/detect-text-truncation.directive';
import { BadgeModule } from '@go-modules/components/badge/badge.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		CardContainerModule,
		FormatTimeModule,
		EllipsisWithCountModule,
		ThumbnailModule,
		GoMaterialModule,
		DotIndicatorModule,
		SessionMenuModule,
		MenuModule,
		LoadingModule,
		DetectTextTruncationDirective,
		BadgeModule
	],
	declarations: [
		SessionCardComponent
	],
	exports: [
		SessionCardComponent
	]
})
export class SessionCardModule {}
